module.exports = __webpack_public_path__ + "static/TFP-logo-header-white.fb6ae1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TFP-logo-header-white.png
// module id = 155
// module chunks = 114276838955818